import jQuery from "jquery";
(function ($) {
    $(document).on("click", ".tab-link", function (e) {
        const $tabsContainer = $(this).closest("[data-tabs]");
        const isDeeplinkEnabled = $tabsContainer.data("deep-link") === true;
        setTimeout(() => {
            if (!isDeeplinkEnabled) {
                history.replaceState(
                    null,
                    null,
                    window.location.pathname + window.location.search
                );
            }
        }, 10);
    });

    $(document).on("click", ".accordion-title", function (e) {
        const $accordionItem = $(this).closest("[data-accordion-item]");
        const $accordionContainer = $accordionItem.closest("[data-accordion]");
        const isDeeplinkEnabled =
            $accordionContainer.data("deep-link") === true;
        setTimeout(() => {
            if (!isDeeplinkEnabled) {
                history.replaceState(
                    null,
                    null,
                    window.location.pathname + window.location.search
                );
            }
        }, 10);
    });
})(jQuery);
